$(document).ready(function(){

    $("img[src=\"//sageandsalt.com/cdn/shop/files/SS_ParfumProduct-23.jpg?v=1746727942&width=1500\"]").attr("alt", "Glass perfume bottle with gold stopper and label on shiny surface");
$("img[src=\"//sageandsalt.com/cdn/shop/files/SS_ParfumProduct_EDIT.jpg?v=1761710893&width=3840\"]").attr("alt", "Two perfume bottles with crystal orbs");
$("img[src=\"//sageandsalt.com/cdn/shop/files/Full_Moon.jpg?v=1761711384&width=3840\"]").attr("alt", "Bottle with gold lid and label, surrounded by burning stick, flower, and herbs");
$("img[src=\"//sageandsalt.com/cdn/shop/files/moon_ring.jpg?v=1761711941&width=3840\"]").attr("alt", "Perfume bottle with fruit and spices");
$("img[src=\"//sageandsalt.com/cdn/shop/files/ELLE_Magazine_Logo_300x300.png?v=1746747395\"]").attr("alt", "Elle Magazine logo");
$("img[src=\"//sageandsalt.com/cdn/shop/files/Bloomberg_logo_300x300.png?v=1746747636\"]").attr("alt", "Bloomberg logo");
$("img[src=\"//sageandsalt.com/cdn/shop/files/Women_s_Wear_Daily_logo_300x300.png?v=1746747654\"]").attr("alt", "Women's wear daily logo");      
$("img[src=\"//sageandsalt.com/cdn/shop/files/New-York-Times-logo_300x300.png?v=1746747336\"]").attr("alt", "New york times logo");
$("img[src=\"//sageandsalt.com/cdn/shop/files/Allure_logo_300x300.png?v=1746747669\"]").attr("alt", "Allure logo");
$("img[src=\"//sageandsalt.com/cdn/shop/files/New_York_Magazine_Logo_300x300.png?v=1746747722\"]").attr("alt", "Newyork magazine logo");       
$("img[src=\"//sageandsalt.com/cdn/shop/files/Forbes_logo_300x300.png?v=1746747685\"]").attr("alt", "Forbes logo");
$('img[src="//sageandsalt.com/cdn/shop/files/Vogue_France_logo_300x300.png?v=1746747699"]').attr('alt', 'Vogue France logo');
$('label[for="country-filter-input"]').removeAttr('for');
$('input[name="country_filter"]').attr('aria-label', 'Filter by country');
$("h2:empty").append("<span style='display:none'>.</span>");
$("h3>br:empty").append("<span style='display:none'>.</span>");
setTimeout(() => {
    $('a[id^="CardLink"]').removeAttr('aria-labelledby');
$('a[id^="StandardCardNoMediaLink"]').removeAttr('aria-labelledby');
}, 1000);
$('button[aria-controls^="GalleryViewer-template"]').removeAttr('aria-describedby');

$('#main-collection-filters').removeAttr('aria-labelledby');
$('img[src="https://cdn.shopify.com/s/files/1/0532/9285/9573/files/Evil_Eye_Bag_Charm_480x480.jpg?v=1721604157"]').attr('alt', 'Evil eye bag charm');
let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;


   
    if ( $('#goog-gt-votingInputSrcLang').length) {

$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
 
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 20) {
        clearInterval(Intervaltime_google);
       
    }
}
$('img[src="//sageandsalt.com/cdn/shop/files/Sage_Salt_Logo_White.svg?v=1746726709&width=600"]').attr('alt', 'Sage and Salt logo');
$('#block-c38b75a83d2af418bf52 h2').append("<span style='display:none'>.</span>")

$('h3:empty').append("<span style='display:none'>.</span>");
$('img[src="https://cdn.shopify.com/s/files/1/0532/9285/9573/products/CarvedLabradoriteEyeAmulet_480x480.jpg?v=1625755356"]').attr('alt', 'Carved labradorite eye amulet');
$('img[src="https://cdn.shopify.com/s/files/1/0532/9285/9573/products/CitrineCrystalSage-and-salt_480x480.jpg?v=1629563324"]').attr('alt', 'Citrine crystal');

console.log("ready");
});
